import { render } from "./SourceSet.vue?vue&type=template&id=47becc9e"
import script from "./SourceSet.vue?vue&type=script&lang=js"
export * from "./SourceSet.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__